import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PROJECTS_FEATURE_KEY,
  ProjectsState,
  projectsAdapter
} from './projects.reducer';

// Lookup the 'Project' feature state managed by NgRx
export const getProjectState = createFeatureSelector<ProjectsState>(PROJECTS_FEATURE_KEY);

const { selectAll, selectEntities, selectIds, selectTotal } = projectsAdapter.getSelectors();

export const getProjectsLoaded = createSelector(
  getProjectState,
  (state: ProjectsState) => state.projectsLoaded
);

export const getProjectsLoadError = createSelector(
  getProjectState,
  (state: ProjectsState) => state.projectsLoadError
);

export const getAddProjectSuccess = createSelector(
  getProjectState,
  (state: ProjectsState) => state.addProjectSuccess
);


export const getAddProjectError = createSelector(
  getProjectState,
  (state: ProjectsState) => state.addProjectError
);


export const getUpdateProjectSuccess = createSelector(
  getProjectState,
  (state: ProjectsState) => state.updateProjectSuccess
);


export const getUpdateProjectError = createSelector(
  getProjectState,
  (state: ProjectsState) => state.updateProjectError
);


export const getDeleteProjectSuccess = createSelector(
  getProjectState,
  (state: ProjectsState) => state.deleteProjectSuccess
);


export const getDeleteProjectError = createSelector(
  getProjectState,
  (state: ProjectsState) => state.deleteProjectError
);


export const getQueryProjectError = createSelector(
  getProjectState,
  (state: ProjectsState) => state.queryProjectLoadError
);

export const getProjects = createSelector(getProjectState, (state: ProjectsState) => selectAll(state));

export const getProjectsDictionary = createSelector(getProjectState, (state: ProjectsState) => state.entities);


export const getActiveProjects = createSelector(getProjects,
  (projects) =>
    projects.filter(item => item.active)
);

export const getActiveProjectsWithSubscription= createSelector(getProjects,
  (projects) =>
    projects.filter(item => {
      if(item.active && item.costModel){
        return item;
      }
    })
);


export const getProjectById = createSelector(getProjects,
  (projects, props) =>
    projects.find(item => item.id === props.id)
);










